import { easeInOutQuint } from './ease-in-out-quint';

export const easing = {
  easeInOutQuint,
};

export type Easing = keyof typeof easing;
